module.exports = __webpack_public_path__ + "static/img/banner.caca2df.png";


//////////////////
// WEBPACK FOOTER
// ./static/answer/banner.png
// module id = Yooa
// module chunks = 1